import { createBrowserRouter, Navigate } from "react-router-dom";
import { RootLayout } from "@/components/root-layout";
import Home from "@/pages/Home";
import AboutUs from "@/pages/AboutUs";
import FAQ from "@/pages/FAQ";
import TeamTraining from "@/pages/TeamTraining";
import Workshops from "@/pages/Workshops";
import WorkshopPage from "@/pages/WorkshopPage";
import MemberShowcase from "@/pages/MemberShowcase";
import MemberShowcaseFunctionPage from "@/pages/MemberShowcaseFunctionPage";
import Curriculum from "@/pages/Curriculum";
import Membership from "@/pages/Membership";
import NextCohortPage from "@/pages/NextCohortPage";
import ContactUs from "@/pages/ContactUs";
import SelfPacedOffer from "@/pages/SelfPacedOffer";
import UgaStudentsPage from "@/pages/UgaStudentsPage";
import PremiumCheckout from "@/pages/PremiumCheckout";
import CheckoutReturn from "@/pages/CheckoutReturn";
import NotFound from "@/pages/NotFound";
import RouteError from "@/pages/RouteError";
import { LEGACY_COHORT_REDIRECTS, NEXT_COHORT_PATH } from "@/lib/cohorts";
import { SELF_PACED_OFFER_PATH } from "@/lib/constants";
import { UGA_STUDENT_PAGE_PATH } from "@/lib/uga-offer";
import { RETIRED_MEMBER_SHOWCASE_REDIRECTS } from "@/lib/member-showcase";
import { LEGACY_FROM_THE_LAB_PATH, MEMBER_SHOWCASE_PATH } from "@/lib/routes";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RouteError />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/about-us", element: <AboutUs /> },
      { path: "/faq", element: <FAQ /> },
      { path: "/team-training", element: <TeamTraining /> },
      { path: "/workshops", element: <Workshops /> },
      { path: "/workshops/:slug", element: <WorkshopPage /> },
      { path: "/curriculum", element: <Curriculum /> },
      { path: MEMBER_SHOWCASE_PATH, element: <MemberShowcase /> },
      ...Object.entries(RETIRED_MEMBER_SHOWCASE_REDIRECTS).map(
        ([slug, destination]) => ({
          path: `${MEMBER_SHOWCASE_PATH}/${slug}`,
          element: <Navigate to={destination} replace />,
        }),
      ),
      {
        path: `${MEMBER_SHOWCASE_PATH}/:slug`,
        element: <MemberShowcaseFunctionPage />,
      },
      {
        path: LEGACY_FROM_THE_LAB_PATH,
        element: <Navigate to={MEMBER_SHOWCASE_PATH} replace />,
      },
      { path: "/membership", element: <Membership /> },
      { path: NEXT_COHORT_PATH, element: <NextCohortPage /> },
      ...LEGACY_COHORT_REDIRECTS.map((path) => ({
        path,
        element: <Navigate to={NEXT_COHORT_PATH} replace />,
      })),
      { path: "/contact", element: <ContactUs /> },
      { path: SELF_PACED_OFFER_PATH, element: <SelfPacedOffer /> },
      { path: UGA_STUDENT_PAGE_PATH, element: <UgaStudentsPage /> },
      { path: "/checkout/premium", element: <PremiumCheckout /> },
      { path: "/checkout/return", element: <CheckoutReturn /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
